// Valid calendar year range for date inputs and stored dates.
export const MIN_VALID_DATE_YEAR = 1900;
export const MAX_VALID_DATE_YEAR = 2100;
